import axiosInstance from "src/utils/axiosInstance";


export const getData = async (url: string) => {
  try {
    console.log("GET", url);
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch data");
  }
};

export const postData = async (url: string, { arg }: {arg: any}) => {
  try {
    console.log("POST", url);
    console.log("DATA", arg)
    let config: any = {
      headers: {}
    };
    if (arg instanceof FormData) {
      config['headers']['Content-Type'] = 'multipart/form-data';
      config['headers']['Accept'] = '*';
      console.log(config)
    } else {
      config['headers']['Content-Type'] = 'application/json';
      console.log(config)
    }
    const response = await axiosInstance.post(url, arg, config);
    return response.data;
  } catch (error) {
    throw new Error(error);
  }
};

export const putData = async (url: string, {arg} : { arg: any }) => {
  try {
    console.log("PUT", url);
    console.log("DATA", JSON.stringify(arg));
    let config: any = {
      headers: {},
    };
    console.log(arg instanceof FormData, 'form put')
    if (arg instanceof FormData) {
      config['headers']['Content-Type'] = 'multipart/form-data';
      console.log(config)
    } else {
      config['headers']['Content-Type'] = 'application/json';
      console.log(config)
    }
    const response = await axiosInstance.put(url, arg, {headers: config.headers, maxContentLength: 50 * 1024 * 1024 * 1024 });
    return response.data;
  } catch (error) {
    console.error("Error put: ", error)
    console.log(error)
    throw error;
  }
};

export const removeData = async (url: string, { arg }: { arg: any }) => {
  try {
    console.log("DELETE", url);
    console.log("DATA", JSON.stringify(arg));

    let config: any = { headers: {} };

    console.log(arg instanceof FormData, 'form delete');

    if (arg instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    } else {
      config.headers['Content-Type'] = 'application/json';
    }

    const response = await axiosInstance.delete(url, {
      headers: config.headers,
      data: arg,
      maxContentLength: 50 * 1024 * 1024 * 1024
    });

    return response.data;
  } catch (error) {
    console.error("Error delete: ", error);
    throw new Error(error);
  }
};

